<style lang="scss" scoped>
.camera {
  width: 416px;
  height: 178px;
  margin-top: 20px;

  .plane {

    // padding-top: 5px;
    .equipment {
      width: 100%;
      position: absolute;
      top: 66px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 0 20px;

      .normal {
        display: flex;
        align-items: center;
        text-align: center;

        p {
          font-size: 18px;
          height: 27px;
          line-height: 27px;
        }
        p:nth-child(2){
          height: 60px;
          width: 63px;
          line-height: 50px;
          margin-left: 10px;
        }
        .numb1 {
          font-size: 36px;
          font-family: "dina";
          span {
            font-size: 48px;
            font-family: "dina";
            color: rgba(255, 255, 255, 0.7);
          }
        }

        .numb2 {
          font-size: 36px;
          color: #2D82FF;
          font-family: "dina";
        }

        .numb3 {
          font-size: 36px;
          color: #F1802F;
          font-family: "dina";
        }
        .numb4 {
          font-size: 36px;
          color: #F1802F;
          font-family: "dina";
        }
      }
    }
  }
}
</style>

<template>
  <div class="camera" @click="toEquOpe">
    <custom-plane title="设备运维" class="plane" :iconImg="require('@/assets/compImg/icon/equipment.png')">
      <div class="equipment">
        <div class="normal">
          <p>全部数量</p>
          <p class="numb1">{{ numb1}}</p>
        </div>
        <div class="normal">
          <p>正常数量</p>
          <p class="numb2">{{ numb2 }}</p>
        </div>
        <div class="normal">
          <p>离线数量</p>
          <p class="numb3">{{ numb3 }}</p>
        </div>
        <div class="normal">
          <p>故障数量</p>
          <p class="numb4">{{ numb4 }}</p>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  methods: {
    toEquOpe() {
      this.$router.push({ name: "fourth" });
    },
  },
  props: {
    numb1: Number,
    numb2: Number,
    numb3: Number,
    numb4: Number
  }
};
</script>
